var exports = {
  "kL": "container__7PAUKT",
  "Kf": "inputContainer__S0_V7z",
  "lY": "popup__oVkJI9",
  "Qq": "text__Br-ksr",
  "Tj": "colors__EZKtMy",
  "yW": "color__qwduga",
};

module.exports = exports;
